import React from "react";

const HeartIcon = ({
  filled = false,
  size = 24,
  ...props
}: React.SVGProps<SVGSVGElement> & { filled?: boolean; size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={filled ? "#FE5A97" : "none"}
    xmlns="http://www.w3.org/2000/svg"
    stroke="#FE5A97"
    strokeWidth="2"
    {...props}
  >
    <path
      d="M12 21C12 21 5 14.7 5 9.5C5 6.42 7.42 4 10.5 4C11.88 4 13.18 4.66 14 5.69C14.82 4.66 16.12 4 17.5 4C20.58 4 23 6.42 23 9.5C23 14.7 16 21 16 21H12Z"
      fill={filled ? "#FE5A97" : "none"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HeartIcon;
